<div class="site-header">
    <!-- <app-header-topbar></app-header-topbar> -->
    <app-header-message></app-header-message>

    <div *ngIf="layout === 'classic' && !iconeEnabled" class="site-header__middle container">
        <div class="site-header__logo">
            <a routerLink="/">
                <img *ngIf="logo" [src]="logo" class="azienda-logo-icon-large">
                <span *ngIf="!logo" style="font-size: 24px; font-weight: 700;">{{store.name}}</span>
            </a>
        </div>
        <div class="site-header__search">
            <app-search location="header"></app-search>
        </div>
        <div class="site-header__phone">
            <div class="site-header__phone-title">Servizio Clienti</div>
            <div class="site-header__phone-number">{{ store.primaryPhone }}</div>
        </div>
    </div>

    <div class="site-header__nav-panel">
        <app-header-nav
            [departments]="!iconeEnabled"
            [logo]="iconeEnabled"
            [search]="iconeEnabled"
            stickyMode="alwaysOnTop"
        ></app-header-nav>
    </div>
</div>
